import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Layout = ({ children }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <div className="site-wrapper">
      <div className="ambient-glow" />

      <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
        <div className="container header__inner">
          <Link to="/" className="logo">
            <img src="/images/logos/full-speed-white.png" alt="Full Speed AI" className="logo__img" />
          </Link>

          <div className="header__partners">
            <img src="/images/logos/dell-technologies.png" alt="Dell Technologies" className="header__partner-img header__partner-img--dell" />
            <div className="header__partner-divider" />
            <img src="/images/logos/nvidia.png" alt="NVIDIA" className="header__partner-img header__partner-img--nvidia" />
          </div>

          <nav className="nav desktop-nav">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`nav__link ${location.pathname === link.to ? 'nav__link--active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <Link to="/contact" className="btn btn--primary header__cta">
            Book a Dream Call
          </Link>

          <button
            className={`mobile-toggle ${mobileOpen ? 'mobile-toggle--open' : ''}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>

        <AnimatePresence>
          {mobileOpen && (
            <motion.div
              className="mobile-menu"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              {navLinks.map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`mobile-menu__link ${location.pathname === link.to ? 'mobile-menu__link--active' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
              <Link to="/contact" className="btn btn--primary" style={{ marginTop: '1rem', width: '100%', textAlign: 'center' }}>
                Book a Dream Call
              </Link>
            </motion.div>
          )}
        </AnimatePresence>
      </header>

      <main>{children}</main>

      <footer className="footer">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
              <Link to="/" className="logo" style={{ marginBottom: '1rem', display: 'inline-flex' }}>
                <img src="/images/logos/full-speed-white.png" alt="Full Speed AI" className="logo__img" />
              </Link>
              <p className="footer__tagline">
                Custom AI solutions built for the way you work.
              </p>
            </div>

            <div className="footer__col">
              <h4 className="footer__heading">Navigate</h4>
              {navLinks.map(link => (
                <Link key={link.to} to={link.to} className="footer__link">{link.label}</Link>
              ))}
            </div>

            <div className="footer__col">
              <h4 className="footer__heading">Connect</h4>
              <a href="mailto:info@gofullspeed.ai" className="footer__link">info@gofullspeed.ai</a>
              <Link to="/contact" className="footer__link">Book a Dream Call</Link>
            </div>
          </div>

          <div className="footer__bottom">
            <p>&copy; {new Date().getFullYear()} Full Speed AI. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
